import cogoToast from 'cogo-toast';
import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index';
import apiCall from '../../../apiCall.js';

import { DOWNLOAD_PRICING, DOWNLOAD_PRICING_SUCCESS, DOWNLOAD_PRICING_ERROR } from './../../../actionType.js';

function* downloadPricing({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { type, configurationId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/${type}/download/${configurationId}`,
      method: 'GET',
      isOctetStream: true,
      headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success('File uploaded successfully');
      yield put({
        type: DOWNLOAD_PRICING_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({ type: DOWNLOAD_PRICING_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: DOWNLOAD_PRICING_ERROR, payload: error });
  }
}

export function* watchdownloadPricing() {
  yield takeEvery(DOWNLOAD_PRICING, downloadPricing);
}

function* downloadPricingSaga() {
  yield all([fork(watchdownloadPricing)]);
}

export default downloadPricingSaga;
